import React from "react";
import reac from "../img/our-team/ccr.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faFacebook, faLinkedin, faInstagram } from '@fortawesome/free-brands-svg-icons';

const SocailresponsibilitesAdvviser = () => {
    const socialLinkStyle = {
        margin: "0 10px",
        color: "#000",
        fontSize: "30px",
    };

    return (
        <div style={{ backgroundColor: "white", padding: "40px" }}>
            <div className="row d-flex justify-content-center">
                <div className="col-md-12">
                    {/* <h1 style={{ fontSize: '48px', textAlign: 'center' }}>
                        Meet Our <span style={{ color: 'rgb(245, 134, 52)' }}>Experts</span>
                    </h1> */}
                </div>
                <div className="col-md-9">
                    <div className="row" style={{ border: "3px solid black", borderRadius: "20px", overflow: "hidden" }}>
                        <div className="col-xl-3 col-md-6 p-0" style={{ position: "relative" }}>
                            <img
                                src={reac}
                                alt=""
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    borderTopLeftRadius: '20px',
                                    borderBottomLeftRadius: '20px',
                                }}
                                className="adviser-img"
                            />
                        </div>
                        <div className="ProvisorIIA col-xl-9 col-md-12" style={{ padding: "49px", background: '#05839e' }}>
                            <p className="Provisor-IIA-para" style={{ textAlign: "left", marginBottom: "20px", fontSize: '16px', color: '#fff' }}>
                                "We believe in creating a better world for future generations. Our commitment to social responsibility is reflected in our actions and our positive impact on the communities we serve."
                            </p>
                            <p style={{ fontSize: '18px', fontWeight: '700', color: '#fff' }}>C Chandra Sekhar Reddy</p> <br />
                            <p style={{ fontWeight: '900', marginBottom: '10px', color: '#fff' }}>CEO & Founder</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SocailresponsibilitesAdvviser;
